import script from "./GameChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GameChart.vue?vue&type=script&setup=true&lang=js"

import "./GameChart.vue?vue&type=style&index=0&id=483a1e8e&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-483a1e8e"]])

export default __exports__